import { render, staticRenderFns } from "./AddEditProfessors.vue?vue&type=template&id=cb9110be"
import script from "./AddEditProfessors.vue?vue&type=script&lang=js"
export * from "./AddEditProfessors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports